import { useEffect } from 'react'

export const useKeyDown = (keys: string[], memorized: any[], callback: () => void) => {
  const onKeyDown = (evt: KeyboardEvent) => {
    if (keys.find((key) => key === evt.key)) {
      callback()
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', onKeyDown)
    return () => {
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [memorized])
}

export default useKeyDown
